<svg
  width="17"
  height="16"
  viewBox="0 0 17 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_5074_16045)">
    <path
      d="M6.38762 6.00016C6.54435 5.55461 6.85372 5.1789 7.26092 4.93958C7.66812 4.70027 8.14688 4.61279 8.6124 4.69264C9.07792 4.77249 9.50016 5.01451 9.80433 5.37585C10.1085 5.73718 10.275 6.19451 10.2743 6.66683C10.2743 8.00016 8.27428 8.66683 8.27428 8.66683M8.32762 11.3335H8.33428M14.9943 8.00016C14.9943 11.6821 12.0095 14.6668 8.32762 14.6668C4.64572 14.6668 1.66095 11.6821 1.66095 8.00016C1.66095 4.31826 4.64572 1.3335 8.32762 1.3335C12.0095 1.3335 14.9943 4.31826 14.9943 8.00016Z"
      stroke="#787E87"
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
  <defs>
    <clipPath id="clip0_5074_16045">
      <rect
        width="16"
        height="16"
        fill="white"
        transform="translate(0.327637)"
      />
    </clipPath>
  </defs>
</svg>
